import { useState, useEffect } from 'react';

import { useAssignTest, useInTest, useOnce } from '../../../../hooks';
import {
  CLIENT_REVIEW_TAGS_TEST_NAME, CLIENT_REVIEW_TAGS_TEST_PERCENT,
} from '../constants';

type ProfileTabState = {
  tabs: string[];
  activeTabIndex: number;
  setActiveTabIndex: (tabIndex: number) => void;
  showServices: boolean;
  showProducts: boolean;
  showReviews: boolean;
  showAboutTab: boolean;
  isInReviewTagFiltersTest: boolean;
};

type ProfileTabStateProps = {
  usingProducts: boolean;
};

const useProfileTabState = (
  { usingProducts }: ProfileTabStateProps,
): ProfileTabState => {
  const [tabs, setTabs] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const showServices = tabs[activeTabIndex] === 'Services';
  const showProducts = tabs[activeTabIndex] === 'Products';
  const showReviews = tabs[activeTabIndex] === 'Reviews';
  const showAboutTab = tabs[activeTabIndex] === 'About';

  const isInReviewTagFiltersTest = useInTest(CLIENT_REVIEW_TAGS_TEST_NAME);
  const assignTest = useAssignTest(CLIENT_REVIEW_TAGS_TEST_NAME, CLIENT_REVIEW_TAGS_TEST_PERCENT);

  useEffect(() => {
    const result = ['Services', 'Reviews', 'About'];

    if (usingProducts) {
      result.push('Products');
    }

    setTabs(result);
  }, [usingProducts]);

  useOnce(() => {
    assignTest();
  }, showReviews || null);

  return {
    tabs,
    activeTabIndex,
    setActiveTabIndex,
    showServices,
    showProducts,
    showReviews,
    showAboutTab,
    isInReviewTagFiltersTest,
  };
};

export default useProfileTabState;
